export default __webpack_public_path__ + "99c317debc24f337397a479c35b36b3f.png";